<script lang="ts" generics="ITEM">
    import type {Readable} from 'svelte/store';
    import type {Table} from '@tanstack/svelte-table';
    import {getTopMostColumn} from 'shared/ui-widgets/grid/utils';
    import SearchToolbarSection from './SearchToolbarSection.svelte';
    import Checkbox from 'shared/ui-widgets/checkbox/Checkbox.svelte';
    import KpDropdownMenuWrapper from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuWrapper.svelte';

    export let table$: Readable<Table<ITEM>> | null = null;

    function getHidableColumns(table: Table<ITEM>) {
        return table.getAllLeafColumns().filter((column) => column.getCanHide());
    }

    $: anyColumnsHidden = getHidableColumns($table$).some((column) => !column.getIsVisible());
</script>

<SearchToolbarSection icon="eye" additionalClasses="search-toolbar-grid-columns-visibility">
    <KpDropdownMenuWrapper additionalMenuClasses="column-visibility-dropdown-menu">
        <span class:any-column-hidden={anyColumnsHidden} slot="button">Viditelnost sloupců</span>

        <svelte:fragment slot="menu">
            {#each getHidableColumns($table$) as column (column.id)}
                <li>
                    <Checkbox checked={column.getIsVisible()}
                              on:change={(event) => column.toggleVisibility(event.detail.checked)}>

                        {getTopMostColumn(column).columnDef.meta.text} - {column.columnDef.meta.text}
                    </Checkbox>
                </li>
            {/each}
        </svelte:fragment>
    </KpDropdownMenuWrapper>
</SearchToolbarSection>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .any-column-hidden {
        font-weight: 500;
        text-decoration: underline;
        color: var(--accent-blue);
    }

    :global {
        .search-toolbar-grid-columns-visibility .column-visibility-dropdown-menu {
            display: flex;
            flex-direction: column;
            gap: @spacing-s;
        }
    }
</style>